/** One Stripe `currency_options[<currency>]` entry (subset we read). */
export type CurrencyOptionEntry = {
  unit_amount?: number | null;
  tiers?: Array<{
    up_to?: number | null;
    flat_amount?: number | null;
    unit_amount?: number | null;
  }>;
};

/**
 * Extract display amounts (in dollars) from a Stripe per-currency options entry.
 * - Flat (`per_unit`) prices populate `unit_amount` → that is the per-screen price; no base package.
 * - Tiered prices leave `unit_amount` null and carry `tiers`: base package = first tier `flat_amount`,
 *   per-screen overage = last tier `unit_amount` (base and overage can differ — read separately).
 * `unit_amount` is read FIRST so flat add-ons never depend on tiers.
 */
export function readAddonAmounts(entry: CurrencyOptionEntry | undefined): {
  perScreen?: number;
  baseFlat?: number;
} {
  if (!entry) return {};
  if (typeof entry.unit_amount === 'number') return { perScreen: entry.unit_amount / 100 };

  const tiers = entry.tiers;
  if (!Array.isArray(tiers) || tiers.length === 0) return {};

  const result: { perScreen?: number; baseFlat?: number } = {};
  const firstFlat = tiers[0]?.flat_amount;
  if (typeof firstFlat === 'number') result.baseFlat = firstFlat / 100;
  const lastUnit = tiers[tiers.length - 1]?.unit_amount;
  if (typeof lastUnit === 'number') result.perScreen = lastUnit / 100;
  return result;
}
